export default "__VITE_ASSET__CKZ4LsX6__"